import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm$objetoSelected;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Dados Gerais",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 0;
      }
    }
  }, [_c('b-row', [_vm.store.trabalharNumeroInternoOs ? _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Número Interno",
      "label-for": "numero_interno"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off",
      "maxLength": "10"
    },
    model: {
      value: _vm.form.numero_interno,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "numero_interno", $$v);
      },
      expression: "form.numero_interno"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "sm": _vm.store.trabalharNumeroInternoOs ? 4 : 5
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nome"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscarCliente",
    class: {
      hasErrors: _vm.clienteError,
      inputFilled: _vm.clienteFilled
    },
    attrs: {
      "state": _vm.validateState('cliente'),
      "entity-label": "cliente",
      "min-create-length": 3,
      "creating": _vm.criandoCliente,
      "value": _vm.form.cliente,
      "options": _vm.clientes,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setCliente,
      "create": _vm.criarClienteInline,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.nome))]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1), _vm.form.cliente ? _c('RiscoClienteGrupo', {
    attrs: {
      "cliente": _vm.form.cliente
    }
  }) : _vm._e()], 1), _c('button', {
    staticClass: "btn btn-light-primary btn-sm font-weight-bold mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openNovoClienteModal
    }
  }, [_vm._v(" Cadastro completo ")])])], 1), _c('b-col', {
    attrs: {
      "sm": _vm.store.trabalharNumeroInternoOs ? 3 : 4
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Técnico",
      "label-for": "tecnico"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscarTecnico",
    class: {
      hasErrors: _vm.tecnicoError,
      inputFilled: _vm.tecnicoFilled
    },
    attrs: {
      "state": _vm.validateState('tecnico'),
      "entity-label": "técnico",
      "min-create-length": 3,
      "creating": _vm.criandoTecnico,
      "value": _vm.form.tecnico,
      "options": _vm.tecnicos,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setTecnico,
      "create": _vm.criarTecnicoInline,
      "open": _vm.onSearchTecnico,
      "search": _vm.onSearchTecnico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do tecnico ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vendedor",
      "label-for": "vendedor"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscarVendedor",
    class: {
      inputFilled: _vm.vendedorFilled
    },
    attrs: {
      "entity-label": "vendedor",
      "creating": _vm.criandoVendedor,
      "value": _vm.form.vendedor,
      "options": _vm.vendedores,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setVendedor,
      "create": _vm.criarVendedorInline,
      "open": _vm.onSearchVendedor,
      "search": _vm.onSearchVendedor
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.nome))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do vendedor ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Endereço",
      "label-for": "endereco"
    }
  }, [_c('VueSelect', {
    ref: "endereco",
    class: {
      hasErrors: _vm.enderecoError,
      inputFilled: _vm.enderecoFilled
    },
    attrs: {
      "filterable": false,
      "options": _vm.enderecos,
      "value": _vm.form.cliente && _vm.form.cliente.endereco
    },
    on: {
      "input": _vm.setEndereco,
      "search": _vm.onSearchEndereco
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        var _option$cep, _option$logradouro, _option$numero, _option$bairro, _option$cidade$cidade, _option$cidade, _option$cidade$uf, _option$cidade2;
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s("".concat((_option$cep = option.cep) !== null && _option$cep !== void 0 ? _option$cep : "", ", ").concat((_option$logradouro = option.logradouro) !== null && _option$logradouro !== void 0 ? _option$logradouro : "", ", ").concat((_option$numero = option.numero) !== null && _option$numero !== void 0 ? _option$numero : "", ", ").concat((_option$bairro = option.bairro) !== null && _option$bairro !== void 0 ? _option$bairro : "", " - ").concat((_option$cidade$cidade = option === null || option === void 0 || (_option$cidade = option.cidade) === null || _option$cidade === void 0 ? void 0 : _option$cidade.cidade) !== null && _option$cidade$cidade !== void 0 ? _option$cidade$cidade : "", " / ").concat((_option$cidade$uf = option === null || option === void 0 || (_option$cidade2 = option.cidade) === null || _option$cidade2 === void 0 ? void 0 : _option$cidade2.uf) !== null && _option$cidade$uf !== void 0 ? _option$cidade$uf : "")) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(_vm.formatEndereco(option)) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o Endereço ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataEntrada",
      "label-for": "dataEntrada",
      "label": "Data Entrada"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "state": _vm.validateState('dataEntrada'),
      "locale": "pt-br",
      "reset-button": "",
      "reset-button-content": "Limpar",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.dataEntrada,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataEntrada", $$v);
      },
      expression: "form.dataEntrada"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataPrevisao",
      "label-for": "dataPrevisao",
      "label": "Data Previsão"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "state": _vm.validateState('dataPrevisao'),
      "locale": "pt-br",
      "reset-button": "",
      "reset-button-variant": "outline-secondary",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.dataPrevisao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataPrevisao", $$v);
      },
      expression: "form.dataPrevisao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataSaida",
      "label-for": "dataSaida",
      "label": "Data Saída"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "reset-button": "",
      "reset-button-content": "Limpar",
      "state": _vm.validateState('dataSaida'),
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.dataSaida,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataSaida", $$v);
      },
      expression: "form.dataSaida"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "proxRevisao",
      "label-for": "proxRevisao",
      "label": "Próxima Revisão"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "reset-button": "",
      "reset-button-content": "Limpar",
      "state": _vm.validateState('proxRevisao'),
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.proxRevisao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "proxRevisao", $$v);
      },
      expression: "form.proxRevisao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataConclusao",
      "label-for": "dataConclusao",
      "label": "Data Conclusão"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "reset-button": "",
      "reset-button-content": "Limpar",
      "state": _vm.validateState('dataConclusao'),
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.dataConclusao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "dataConclusao", $$v);
      },
      expression: "form.dataConclusao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Garantia",
      "label-for": "garantia"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off",
      "maxLength": 50
    },
    model: {
      value: _vm.form.garantia,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "garantia", $$v);
      },
      expression: "form.garantia"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Solicitante",
      "label-for": "solicitante"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off",
      "maxLength": 50
    },
    model: {
      value: _vm.form.solicitante,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "solicitante", $$v);
      },
      expression: "form.solicitante"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Hora Agendamento",
      "label-for": "horaAgendamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "time"
    },
    model: {
      value: _vm.form.horaAgendamento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "horaAgendamento", $$v);
      },
      expression: "form.horaAgendamento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Local do Atendimento",
      "label-for": "local_atendimento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off",
      "maxLength": "100"
    },
    model: {
      value: _vm.form.local_atendimento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "local_atendimento", $$v);
      },
      expression: "form.local_atendimento"
    }
  })], 1)], 1), _vm.form.cliente.tipo_atacado ? _c('b-col', {
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      "sm": "4"
    }
  }, [_c('span', {
    staticClass: "label label-lg label-inline label-light-warning"
  }, [_vm._v("Tipo Atacado")])]) : _vm._e(), _vm.listaPreco ? _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" Lista de preço aplicada: "), _c('span', {
    staticClass: "font-weight-bold text-primary"
  }, [_vm._v(_vm._s(_vm.listaPreco.descricao))])])]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "novoClienteOsModal",
      "centered": "",
      "size": "xl",
      "title": "Novo Cliente",
      "hide-footer": "",
      "body-class": "p-0 novo-cliente-os-modal-body"
    },
    on: {
      "hidden": _vm.resetNovoClienteModal
    }
  }, [_c('PessoaForm', {
    attrs: {
      "url": "/pessoa/create",
      "pessoa": _vm.novaPessoa,
      "hide-tipo-pessoa": true,
      "force-cliente": true,
      "redirect-on-save": false
    },
    on: {
      "saved": _vm.handleNovoClienteSaved,
      "cancel": function cancel($event) {
        return _vm.$bvModal.hide('novoClienteOsModal');
      }
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "confirmObjectModal",
      "centered": "",
      "title": "Vários Objetos para um mesmo cliente"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click() {
              cancel();
              _vm.openModal = false;
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "confirmObject",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.confirmObject
          }
        }, [_vm._v(" Confirmar ")])];
      }
    }])
  }, [_c('b-row', [_c('b-col', [_c('p', [_vm._v(" Este cliente possui vários objetos cadastrados. Por favor, selecione o objeto desejado abaixo. ")])])], 1), _c('b-row', [_c('b-col', [_c('b-form-group', [_c('VueSelect', {
    ref: "buscarObjeto",
    attrs: {
      "filterable": false,
      "searchable": false,
      "options": _vm.objetosFetched,
      "clearSearchOnSelect": true
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.descricao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.objetoSelected,
      callback: function callback($$v) {
        _vm.objetoSelected = $$v;
      },
      expression: "objetoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do objeto ")])], 2)], 1)], 1)], 1), ((_vm$objetoSelected = _vm.objetoSelected) === null || _vm$objetoSelected === void 0 || (_vm$objetoSelected = _vm$objetoSelected.identificadores) === null || _vm$objetoSelected === void 0 ? void 0 : _vm$objetoSelected.length) > 0 ? _c('b-row', _vm._l(_vm.ordenarIdentificadores(_vm.objetoSelected.identificadores), function (identificador) {
    return _c('b-col', {
      key: identificador.id_identificador,
      attrs: {
        "sm": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": identificador.descricao,
        "label-for": identificador.descricao
      }
    }, [_c('b-form-input', {
      attrs: {
        "value": identificador.value,
        "disabled": ""
      }
    })], 1)], 1);
  }), 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };